import React from 'react';
import './ChatHeader.css';

function ChatHeader({ showSources, onToggleSources, onShowTechStack, onShowContact }) {
  return (
    <div className="chat-header">
      <div className="header-content">
        <div className="header-main">
          <div className="header-info">
            <div className="header-logo-title">
              <img src="/logo.png" alt="Philipp Staufenberger" className="header-logo" />
              <div className="header-text">
                <div className="header-title-row">
                  <h1>Philipp Staufenberger</h1>
                  <button className="info-icon-button" onClick={onShowContact} title="Kontaktinformationen">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 16v-4M12 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </button>
                </div>
                <p className="subtitle">AI & Data Automation Engineer</p>
              </div>
            </div>
          </div>
          <div className="header-settings">
            <label className="sources-toggle">
              <input
                type="checkbox"
                checked={showSources}
                onChange={onToggleSources}
                className="sources-checkbox"
              />
              <span className="toggle-label">
                <svg className="toggle-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Quellen anzeigen
              </span>
            </label>
            <button className="techstack-button" onClick={onShowTechStack}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>TechStack anzeigen</span>
            </button>
          </div>
        </div>
        <div className="tech-badges-container">
          <span className="tech-label">TechStack:</span>
          <div className="tech-badges">
            <span className="badge badge-primary">EmbeddingGemma</span>
            <span className="badge badge-secondary">GPT-4</span>
            <span className="badge badge-accent">LangChain</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatHeader;
